import { render } from "./HeroSectionFive.vue?vue&type=template&id=89b8ca78"
import script from "./HeroSectionFive.vue?vue&type=script&lang=js"
export * from "./HeroSectionFive.vue?vue&type=script&lang=js"

import "./HeroSectionFive.vue?vue&type=style&index=0&id=89b8ca78&lang=css"

import exportComponent from "C:\\Users\\user\\Documents\\Progetti\\IFT-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__